module.exports = __webpack_public_path__ + "static/media/recogehojasespatula.26c7860f.jpg";